import React, {
    useContext,
    useState,
} from 'react';
import { useQuery, useMutation } from '@tanstack/react-query';

import { refetchBasketData, NotificationContext, handleError } from "../router"

import * as CONSTANTS from "../constants";
import * as QUERIES from "../query-functions";

import TicketTypeSelect from '../components/ticket-type-select'
import LoadingIndicator from '../components/loading-indicator';
import CrossIcon from "../svg/cross"

export default function BasketTicketItem (props) {

    const {notification, setNotification} = useContext(NotificationContext);

    const [inEditMode, setInEditMode] = useState(false);

    const { 
        data: priceListData,
    } = useQuery({
        queryKey: ['priceListData', CONSTANTS.INSTANCE_ID],
        queryFn: () => QUERIES.getInstancePriceList(CONSTANTS.INSTANCE_ID),
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 86400000,
        onError: (error) => {
            handleError(error.message, setNotification);
        },
    });
    
    const removeTicket = useMutation({
        mutationFn: () => QUERIES.removeTickets([props.ticket.id]),
        onError: (error) => {
            handleError(error.message, setNotification);
        },
        onSuccess: () => {
            refetchBasketData();
        },
    })

    return (
        <li className='basket-item__ticket-list--item'>
            <p className='basket-item__ticket-list--area'>{props.ticket.planName} {props.ticket.seatName}</p>

            {inEditMode ?
                isInstancePending ?
                    <LoadingIndicator />
                    :
                    <TicketTypeSelect ticket={props.ticket} pricelist={priceListData} setInEditMode={setInEditMode} /> 
                :
                props.ticket.planName != props.ticket.ticketType.name &&
                    <p className='basket-item__ticket-list--type'>{props.ticket.ticketType.name}</p>
            }

            <p className='basket-item__ticket-list--price'>
                <span className="sr-text">Ticket price</span>
                £{props.ticket.total.toFixed(2)}
                {props.ticket.discount ?
                    <span className='basket-item__ticket-list--price__discount'>
                        <span className="sr-text">Discount</span>
                        -£{props.ticket.discount.toFixed(2)}
                    </span>
                :null}
            </p>
            
            <div className='basket-item__ticket-list--amend-ticket'>
            
                {!inEditMode &&
                    <button type="button" onClick={() => setInEditMode(true)} className='btn--edit'>
                        Edit
                    </button>
                }

                <button type="button" onClick={() => removeTicket.mutateAsync()} className='btn btn--remove'>
                    <span className='sr-text'>Remove ticket</span>
                    <CrossIcon />
                </button>
            </div>
        </li>
    )
}